import { isNumber } from 'lodash';

export const number = (value: any) => {
    if (!value) return 0;

    if (isNumber(value)) return value;

    if (typeof parseInt(value) === 'number') return parseInt(value);

    return 0;
};

export const numberToString = (number: number, length = 2) => {
    let value: string = number.toString();
    while (value.length < length) value = '0' + value;
    return value;
};
